<template>
    <div id="c">
        <header class="lmy-header lmy-header-w">
            <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
            {{details.HotelName}}
        </header>
        <div class="lmy-hotel-detail" ref="hoteldetail">
            <ul class="filter-bar">
                <li :class="filterBarNum === 0?'active':'' " @click="positionFn(0)"><span>酒店介绍</span></li>
                <li :class="filterBarNum === 1?'active':'' " @click="positionFn(1)"><span>设施政策</span></li>
                <li :class="filterBarNum === 2?'active':'' " @click="positionFn(2)"><span>酒店政策</span></li>
                <li :class="filterBarNum === 3?'active':'' " @click="positionFn(3)"><span>交通和周边</span></li>
            </ul>
            <!-- 酒店介绍 -->
            <div class="detail-content">
                <div class="title">酒店介绍</div>
                <p class="info">{{details.BuildOn?(details.BuildOn.split('-')[0])+'年开业':''}}  {{details.LastDecorationOn?(details.LastDecorationOn.split('-')[0])+'年装修':''}}</p>
                <p class="info">{{details.SellingPoint}}</p>
                <!-- <p class="info" v-html="details.Intro"></p> -->
                <p class="info"  v-html="Intro"></p>
                
            </div>
            <div class="detail-content" id="facilities">
                <div class="title">设施服务</div>

                <div  v-for="(fcGroup,key) in details.FacilitesByGroup" >
                    <h5 class="sub-title">{{key}}</h5>
                    <ul class="facility-list">
                        <li v-for="eqmt in fcGroup">
                            <span>{{eqmt}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 酒店政策 -->
            <div class="detail-content" id="hotelPolicy">
                <div class="title">酒店政策</div>
                <div  class="hotel-view" v-for="(pl,key) in details.Policies">
                    <h5 class="sub-title">{{key}}</h5>
                    <p class="info">{{pl}}</p>
                </div>
            </div>
            <div class="detail-content" id="traffic">
                <div class="title">交通周边</div>
            </div>

            <!-- 交通和周边 -->

            <mapView :mapData="mapData" v-if="mapData.m1&&mapData.m2"></mapView>

        </div>

    </div>

</template>
<script>
    import eqmtList from './../common/equitment.js'
    import mapView from './../common/cmpnt/mapView.vue'//地图
    export default{
        name:'hotel-readme',
        components:{
            mapView
        },
        data(){
            return{
                details:JSON.parse(this.dao.get('hotelReadmeView')),
                Intro:'',
                eqmtList:eqmtList,
                filterBarNum: 0,
                mapData:{
                    lat:  Number(JSON.parse(this.dao.get('hotelReadmeView')).Lat),
                    lng:  Number(JSON.parse(this.dao.get('hotelReadmeView')).Lon),
                    m1:  Number(this.dao.get('hotelListSearchParams')?JSON.parse(this.dao.get('hotelListSearchParams')).MyLon:''),
                    m2:  Number(this.dao.get('hotelListSearchParams')?JSON.parse(this.dao.get('hotelListSearchParams')).MyLat:''),
                    from: 1,
                },
                test:"&lt;br/&gt;地理位置：深圳桔钓沙莱华酒店位于深圳东部大鹏半岛东岸，坐享1公里醉美桔钓沙天然海岸。<br/>客房：246间现代雅致的东南亚风情客房和海景别墅，豪华、舒适、宽敞。全部拥有宽大阳台，欣赏视角极佳的山海美景。&lt;br&gt;餐饮：六间独具风味的餐厅与酒吧"
            }
        },
        created(){
            this.Intro=JSON.parse(this.dao.get('hotelReadmeView')).Intro.replace(new RegExp('&lt;br&gt;','g'),'<br/>')
        },
        
        methods:{
            // 设置标题行的随屏滚动位置监听
            initWindowScrollEventListener() {
                if(this.$refs['hoteldetail']) {
                    window.addEventListener('touchstart', this.positionFn);
                    window.addEventListener('touchmove',this.positionFn);
                    window.addEventListener('touchend',this.positionFn);
                    window.addEventListener('scroll',this.positionFn);
                }
            },
            positionFn (num) {
                var ss = document.getElementById('facilities');//设施
                var hp = document.getElementById('hotelPolicy');//酒店政策
                var tr = document.getElementById('traffic');//交通
                var bar = document.getElementsByClassName('filter-bar')
                var head = document.getElementsByTagName('header');
                switch(num){
                    case 0:
                    window.scrollTo(0,0);
                    this.filterBarNum = 0;
                    break;
                    case 1:
                    window.scrollTo(0,ss.offsetTop - head[0].offsetHeight - bar[0].offsetHeight);
                    this.filterBarNum = 1;
                    break;
                    case 2:
                    window.scrollTo(0,hp.offsetTop - head[0].offsetHeight - bar[0].offsetHeight);
                    this.filterBarNum = 2;
                    break;
                    case 3:
                    window.scrollTo(0,tr.offsetTop - head[0].offsetHeight - bar[0].offsetHeight);
                    this.filterBarNum = 3;
                    break;
                }
                if(typeof num !="number" && this.$refs['hoteldetail']){
                    var windowSrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
                    
                    if(windowSrollTop>tr.offsetTop - 200){
                        this.filterBarNum = 3;
                    }
                    else if(windowSrollTop>hp.offsetTop -200){
                        this.filterBarNum = 2;
                    }
                    else if(windowSrollTop > ss.offsetTop - 200){
                        this.filterBarNum = 1;
                    }
                    else{
                        this.filterBarNum = 0;
                    }

                }

            }
        },
        mounted() {
            this.initWindowScrollEventListener()
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/hotel/view.vue